// Angular
import { DatePipe, NgClass, NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { RouterLink, RouterOutlet } from '@angular/router';
// Directives
import { DropdownDirective } from '@app/landing/shared/directives/dropdown.directive';
import { ToggleDirective } from '@app/landing/shared/directives/toggle.directive';
import { ControlStatusDirective } from '@app/landing/form/directives/control-status.directive';
import { EmailValidDirective } from '@app/landing/form/directives/email-valid.directive';
// Services
import { NewsletterService } from '@app/landing/data/services/newsletter.service';
import { NotificationsService } from '@app/landing/shared/services/notifications.service';
// External
import { finalize } from 'rxjs';

@Component({
  selector: 'app-base-layout',
  imports: [
    DatePipe,
    NgClass,
    NgOptimizedImage,
    FormsModule,
    RouterLink,
    RouterOutlet,
    DropdownDirective,
    ToggleDirective,
    ControlStatusDirective,
    EmailValidDirective
  ],
  templateUrl: './base-layout.component.html'
})
export class BaseLayoutComponent {

  public menuVisible: boolean;
  public today: Date;

  public formSending: boolean;

  constructor(private newsletterService: NewsletterService, private notificationsService: NotificationsService) {
    this.menuVisible = false;
    this.today = new Date();

    this.formSending = false;
  }

  public toggleMenu(): void {
    this.menuVisible = !this.menuVisible;
  }

  public closeMenu(): void {
    this.menuVisible = false;
  }

  public submitNewsletterForm(form: NgForm): void {
    form.control.markAllAsTouched();

    if (form.invalid || this.formSending) {
      return;
    }

    this.formSending = true;
    this.newsletterService.createSubscriber(form.value).pipe(
      finalize(() => {
        this.formSending = false;
      })
    ).subscribe({
      next: () => {
        form.reset();
        this.notificationsService.showSuccess('Wiadomość wysłana poprawnie.');
      },
      error: () => {
        this.notificationsService.showError('Wystąpił błąd podczas wysyłania wiadomości. Spróbuj ponownie później.');
      }
    });
  }
}
